export class NombreNIT {



    constructor(
        public nitConsulta: string
    ) {}

}
